// import { useConnect, useDisconnect, useRequest, useSession } from '@walletconnect/modal-sign-react';

import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { message as msg } from 'antd';

import { DistributionClient } from '../../generated/mlmbox/client/distribution/distribution.client';
import { Empty } from '../../generated/google/protobuf/empty';
import { getToken, isRpcError } from '../../utils/helper';
import Loader from '../Loader/Loader';
import { prize } from '../../assets';
import { useSelector } from 'react-redux';
import { TRootState } from '../../store/store';
import { useSignMessage } from 'wagmi';
import { useAppKit, useAppKitAccount, useDisconnect, useAppKitState } from '@reown/appkit/react';
import { ContractAddress } from '../../shared/api/contract';
import { useNavigate } from 'react-router-dom';
import { transport } from '../../utils/constants.ts';

const AddWallet = () => {
    const wallet = useSelector((state: TRootState) => state.distribution.value?.web3Address);
    const { t } = useTranslation();
    const [disabled, setDisabled] = useState(false);
    const [signing, setSigning] = useState(false);
    const distribClient = new DistributionClient(transport);
    const { signMessageAsync } = useSignMessage();
    const { address, isConnected } = useAppKitAccount();
    const { open: isModalOpen } = useAppKitState();
    const { open } = useAppKit();
    const { disconnect } = useDisconnect();
    const navigate = useNavigate();

    useEffect(() => {
        if (isModalOpen && address && wallet && wallet.toLocaleLowerCase() !== address.toLowerCase()) {
            disconnect();

            alert(
                t('wrong_wallet', {
                    wallet1: `***${address.slice(-5)}`,
                    wallet2: `***${wallet.slice(-5)}`,
                })
            );
            return;
        }

        if (isConnected && address && wallet && wallet.toLocaleLowerCase() !== address.toLowerCase()) {
            disconnect();
            return;
        }

        if (wallet && !isModalOpen) return;
        if (isModalOpen && address && wallet && wallet.toLocaleLowerCase() === address.toLowerCase()) {
            navigate('/contract');
            return;
        }

        if (isConnected) signMessg(address as ContractAddress);
    }, [address, isConnected]);

    async function signMessg(address: ContractAddress) {
        try {
            setDisabled(true);
            setSigning(true);

            const asyncMessage = await distribClient.getSignatureMessage(Empty, {
                meta: { authorization: getToken() },
            });

            if (asyncMessage.status.code !== 'OK') return;

            const message = asyncMessage.response.message;
            console.log(address, isConnected);
            const signedMessage: string = await signMessageAsync({ message, account: address });

            distribClient
                .web3AddressAttachSigned({ message, signature: signedMessage }, { meta: { authorization: getToken() } })
                .then(({ status, response }) => {
                    if (status.code === 'OK') {
                        window.location.reload();
                        // dispatch(setDistribution(response));
                    }
                })

                .catch((e) => {
                    if (isRpcError(e)) {
                        switch (e.message) {
                            case 'WEB3_ADDRESS_BUSY':
                                msg.error(t('address_busy'));
                        }
                    }
                });
        } catch (err) {
            console.error(err);
            disconnect();
            setDisabled(false);
            setSigning(false);
        } finally {
            setDisabled(false);
            setSigning(false);
        }
    }

    return (
        <div className="add-wallet">
            <div className="add-wallet__bg"></div>
            <div className="add-wallet__header">
                {!signing && (
                    <>
                        <img
                            src={prize}
                            alt=""
                        />
                        <h1>{t('ad_h')}</h1>
                    </>
                )}
                {signing && (
                    <>
                        <Loader />
                        <h1 style={{ opacity: disabled ? '0.5' : 1 }}>{t('ad_s')}</h1>
                    </>
                )}
            </div>

            <button
                style={{ opacity: disabled ? '0.5' : 1 }}
                onClick={() => open()}
                disabled={disabled}>
                {t('ad_b')}
            </button>
        </div>
    );
};

export default AddWallet;
